import React from 'react';
import { Form, Input } from 'antd';
import PropTypes from 'prop-types';

const TitleStep = ({ formDataValue, onChange }) => {
  return (
    <div className="form-group">
      <Form.Item
        label="Title"
        name="title"
        rules={[{ required: true, message: 'Please enter a title' }]}
      >
        <Input
          value={formDataValue.title}
          onChange={(e) => onChange({ ...formDataValue, title: e.target.value })}
          placeholder="Type title"
        />
      </Form.Item>
    </div>
  );
};

TitleStep.propTypes = {
  formDataValue: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TitleStep;





